export default {"src":"/_next/static/image/public/images/ic_morning.5e2eb21fd88733b36c1649e7f2e94c75.svg","height":18,"width":18};